import { useMobileViewerUi } from "@/components/common/mobile-viewer-ui-context";
import { SceneFilter } from "@/types/scene-filter";
import {
  CadSmallIcon,
  FaroIconButton,
  GaussianSplattingIcon,
  Img360SmallIcon,
  OverlayDataIcon,
  PointCloudIcon,
} from "@faro-lotv/flat-ui";
import { Tooltip } from "@mui/material";
import { type JSX, type PropsWithChildren } from "react";
import { createPortal } from "react-dom";
import { MobileViewerSheet } from "./mobile-viewer-sheet";

const representations = {
  [SceneFilter.Pano]: { label: "360 photo", Icon: Img360SmallIcon },
  [SceneFilter.PointCloud]: { label: "Point cloud", Icon: PointCloudIcon },
  [SceneFilter.Cad]: { label: "3D model", Icon: CadSmallIcon },
  [SceneFilter.Overlay]: { label: "Combined", Icon: OverlayDataIcon },
  [SceneFilter.GaussianSplats]: {
    label: "Gaussian splats",
    Icon: GaussianSplattingIcon,
  },
};

/** @returns The active representation launcher in the phone canvas. */
export function MobileRepresentationControl({
  value,
  children,
}: PropsWithChildren<{ value: SceneFilter }>): JSX.Element | null {
  const mobileUi = useMobileViewerUi();
  if (!mobileUi?.representationContainer) return null;
  const { label, Icon } = representations[value];
  return createPortal(
    <>
      <Tooltip title={`Change representation: ${label}`}>
        <FaroIconButton
          dark
          aria-label={`Change representation: ${label}`}
          aria-haspopup="dialog"
          aria-expanded={mobileUi.surface === "representation"}
          onClick={() => mobileUi.setSurface("representation")}
          sx={{
            width: 48,
            height: 48,
            borderRadius: 1,
            bgcolor: "#20252b",
            color: "white",
            pointerEvents: "auto",
            boxShadow: 2,
            "&:hover": { bgcolor: "#343b44" },
          }}
        >
          <Icon />
        </FaroIconButton>
      </Tooltip>
      <MobileViewerSheet name="representation" title="Representation">
        {children}
      </MobileViewerSheet>
    </>,
    mobileUi.representationContainer,
  );
}
